import { registerPlugin } from '@capacitor/core';
import { isAndroid } from './platformService.js';

const NativeToast = registerPlugin('NativeToast');

export async function showNativeToast({ message, duration = 5000 }) {
  if (!isAndroid()) return;

  try {
    await NativeToast.show({ message, duration });
  } catch {
    // A missing native plugin must not prevent Android back navigation.
  }
}
